import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { store } from './helpers';
import { App } from './container';

import 'toasted-notes/src/styles.css';
import './styles.scss'
import './mixins.scss'
import './fonts/styles.scss';


render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('app')
);